import { Replay, init, reactRouterV5Instrumentation } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Breadcrumb, BreadcrumbHint } from '@sentry/browser';
import { TAppVersion } from 'api/types';

const supportedVersions: Record<TAppVersion, boolean> = {
  [TAppVersion.DEV]: false,
  [TAppVersion.PROD]: true,
  [TAppVersion.STAGE]: true,
};

const isSentrySupported = (version: TAppVersion): boolean => supportedVersions[version];

const manageBreadcrumbs = (
  breadcrumb: Breadcrumb,
  hint?: BreadcrumbHint,
): Breadcrumb | null => {
  if (breadcrumb.category === 'ui.click') {
    const testId = hint?.event?.target?.getAttribute('data-testid');
    if (testId) {
      breadcrumb.message += testId;
    }

    return breadcrumb;
  }

  return null;
};

const initSentry = (version: TAppVersion) => {
  try {
    if (!isSentrySupported(version)) return;

    init({
      release: process.env.SENTRY_VERSION || '0.1.0',
      environment: version,
      dsn: process.env.SENTRY_FRONT,
      sampleRate: version === TAppVersion.STAGE ? 1 : 0.8,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: reactRouterV5Instrumentation(history),
        }),
        new Replay({
          maskAllText: false,
          maskAllInputs: false,
        }),
      ],
      beforeBreadcrumb(breadcrumb, hint) {
        return manageBreadcrumbs(breadcrumb, hint);
      },
      tracesSampleRate: version === TAppVersion.STAGE ? 1 : 0.8,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1,
    });
  } catch (err) {
    console.log('Failed to initialize Sentry with error: ', err);
  }
};

export default initSentry;
